import React, { useEffect, useState } from "react";
import Layout from "../../layout/default";

import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Box,
  Flex,
  Button,
  Text,
  Input,
  Modal,
  FormControl,
  FormLabel,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Td,
  TableContainer,
  useDisclosure,
  Checkbox,
  useToast,
  Grid,
  Spinner,
  Tooltip,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  useBreakpointValue,
} from "@chakra-ui/react";
import axios from "axios";
import { setToast } from "../../functions/Toastfunction";
import ConfirmationModal from "../../functions/Modals/ConfimationModals";
import { Link, useNavigate } from "react-router-dom";
import { MdDelete, MdEdit } from "react-icons/md";
import { useSelector } from "react-redux";
import AdminRolesMobilePage from "./AdminRolesMobilePage";
import { IoArrowBackCircleOutline } from "react-icons/io5";

const AdminRoles = () => {
  const [roleid, setRoleid] = useState(null);
  const [confirmisOpen, setConfirmisOpen] = useState(false);
  const openConfirmModal = (id) => {
    setConfirmisOpen(true);
    setRoleid(id);
  };
  const navigate = useNavigate();
  const closeConfirmModal = () => setConfirmisOpen(false);
  const [showupdatebutton, setShowupdateButton] = useState(false);
  const [render, setRender] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [roles, setRoles] = useState(null);
  const toast = useToast();
  const [roledetail, setRoleDetail] = useState({
    name: "",
    description: "",
  });
  const [rolecontroller, setRoleController] = useState({
    coach: ["read"],
    course: [],
    cms: [],
    player: [],
    user: [],
    user_group: [],
    contact: [],
    finances: [],
  });
  let accessroles = [
    "coach",
    "course",
    "cms",
    // "player",
    "user",
    "user_group",
    "contact",
    "finances",
  ];

  const userData = useSelector((state) => state.user);

  // Responsive breakpoint
  const isMobile = useBreakpointValue({ base: true, md: false });

  const handleAddRoleButtonClicked = () => {
    setShowupdateButton(false);
    setRoleController({
      coach: [],
      course: [],
      cms: [],
      player: [],
      user: [],
      user_group: [],
      contact: [],
      finances: [],
    });
    setRoleDetail({
      name: "",
      description: "",
    });
    onOpen();
  };
  const handlerolechange = (e) => {
    const { name, value } = e.target;
    // Check if the first character is a space
    if (value.charAt(0) === " ") {
      // Remove the first character (space)
      e.target.value = value.slice(1);
      return;
    }
    setRoleDetail({
      ...roledetail,
      [name]: value,
    });
  };

  const handleAllrole = (e, name) => {
    let newobj = { ...rolecontroller };
    if (newobj[name].length < 3) {
      newobj[name] = [];
      newobj[name].push("read");
      newobj[name].push("write");
      newobj[name].push("delete");
    } else {
      newobj[name] = [];
    }
    setRoleController(newobj);
  };

  const handleReadRole = (e, name) => {
    let newobj = { ...rolecontroller };
    if (e.target.checked) {
      newobj[name].push("read");
    } else {
      newobj[name] = newobj[name].filter((item) => item !== "read");
    }
    setRoleController(newobj);
  };

  const handleWriteRole = (e, name) => {
    let newobj = { ...rolecontroller };
    if (e.target.checked) {
      newobj[name].push("write");
      if (!newobj[name].includes("read")) {
        newobj[name].push("read");
      }
    } else {
      newobj[name] = newobj[name].filter((item) => item !== "write");
    }
    setRoleController(newobj);
  };

  const handleDeleteRole = (e, name) => {
    let newobj = { ...rolecontroller };
    if (e.target.checked) {
      newobj[name].push("delete");
      if (!newobj[name].includes("read")) {
        newobj[name].push("read");
      }
    } else {
      newobj[name] = newobj[name].filter((item) => item !== "delete");
    }
    setRoleController(newobj);
  };

  const [roleLoading, setRoleLoading] = useState(true);
  function getUserRolesfromBackend() {
    setRoleLoading(false);
    const headers = {
      Authorization: sessionStorage.getItem("admintoken"),
    };
    axios({
      method: "GET",
      url: `${process.env.REACT_APP_BASE_URL}/api/academy-user-groups`,
      headers,
    })
      .then((r) => {
        // Handle the nested response structure
        const rolesData = r.data?.data?.userGroups || [];
        console.log(rolesData);
        setRoles(rolesData);
        setRoleLoading(true);
      })
      .catch((err) => {
        if (err.response?.data?.err === "Invalid token") {
          sessionStorage.removeItem("admintoken");
          navigate("/login");
          return;
        }

        if (err.response?.status === 403) {
          setToast(
            toast,
            `You don't have an access to perform this action`,
            "",
            "warning"
          );
        } else {
          setToast(
            toast,
            `${err.response?.data?.err || "An error occurred"}`,
            "",
            "error"
          );
        }
        setRoleLoading(true);
      });
  }

  const [createloader, setCreateLoader] = useState(false);
  const handleCreateRoleHitApi = () => {
    if (createloader) {
      return;
    }
    setCreateLoader(true);
    const headers = {
      Authorization: sessionStorage.getItem("admintoken"),
    };
    axios({
      method: "POST",
      url: `${process.env.REACT_APP_BASE_URL}/api/academy-user-groups`,
      data: { ...roledetail, access_scopes: rolecontroller },
      headers,
    })
      .then((r) => {
        setToast(toast, `Role Created Successfully`, "", "success");
        onClose();
        setRender(!render);
        setCreateLoader(false);
      })
      .catch((err) => {
        if (err.response.data.err === "Invalid token") {
          sessionStorage.removeItem("admintoken");
          navigate("/login");
          return;
        }
        setCreateLoader(false);
        if (err.response.status === 403) {
          setToast(
            toast,
            `You don't have an access to perform this action`,
            "",
            "warning"
          );
        } else {
          const errorMessage = err?.response?.data?.errors?.[0]?.message || "Something went wrong"
          setToast(toast, errorMessage , "", "error");
        }
      });
  };

  function handleEditRoleButtonClicked(item) {
    let obj = {};
    obj.name = item.name;
    obj.description = item.description;
    setRoleDetail(obj);
    let scope = { ...item.access_scopes };
    setRoleController(scope);
    setShowupdateButton(true);
    setRoleid(item._id);
    onOpen();
  }

  const [updateloader, setUpdateLoader] = useState(false);
  function handleupdateRoleHitApi() {
    if (updateloader) {
      return;
    }
    setUpdateLoader(true);
    const headers = {
      Authorization: sessionStorage.getItem("admintoken"),
    };
    axios({
      method: "PATCH",
      url: `${process.env.REACT_APP_BASE_URL}/api/academy-user-groups/${roleid}`,
      data: { ...roledetail, access_scopes: rolecontroller },
      headers,
    })
      .then((r) => {
        setToast(toast, "Role Updated Successfully", "", "success");
        onClose();
        setRender(!render);
        setUpdateLoader(false);
      })
      .catch((err) => {
        if (err.response.data.err === "Invalid token") {
          sessionStorage.removeItem("admintoken");
          navigate("/login");
          return;
        }
        setUpdateLoader(false);
        if (err.response.status === 403) {
          setToast(
            toast,
            `You don't have an access to perform this action`,
            "",
            "warning"
          );
        } else {
          setToast(toast, `${err.response.data.err}`, "", "error");
        }
      });
  }

  const [deleteloader, setdeleteLoader] = useState(false);
  function handleDeleteRoleButtonClickedApiHit() {
    if (deleteloader) {
      return;
    }
    setdeleteLoader(true);
    const headers = {
      Authorization: sessionStorage.getItem("admintoken"),
    };
    axios({
      method: "DELETE",
      url: `${process.env.REACT_APP_BASE_URL}/api/academy-user-groups/${roleid}`,
      headers,
    })
      .then((r) => {
        setdeleteLoader(false);
        setToast(toast, "Role Deleted Successfully", "", "success");
        setRender(!render);
        closeConfirmModal();
      })
      .catch((err) => {
        if (err.response.data.err === "Invalid token") {
          sessionStorage.removeItem("admintoken");
          navigate("/login");
          return;
        }
        setdeleteLoader(false);
        if (err.response.status === 403) {
          setToast(
            toast,
            `You don't have an access to perform this action`,
            "",
            "warning"
          );
        } else {
          const errorData = err.response.data;

          // Check if errorData.errors is an array
          if (Array.isArray(errorData.errors)) {
            const combinedMessages = errorData.errors
              .map((e) => `${e.message}`)
              .join(", "); // Or use "\n" if you want each on a new line

            setToast(toast, combinedMessages, "", "error");
          } else {
            // fallback for non-array error message
            setToast(
              toast,
              `${errorData.message || "Something went wrong"}`,
              "",
              "error"
            );
          }
        }
      });
  }

  useEffect(() => {
    getUserRolesfromBackend();
  }, [render]);

  return (
    <Box w="100%" maxW="none">
      <Layout title="Role | Administration">
        <Flex
          justifyContent={"space-between"}
          alignItems={"flex-start"}
          mb={3}
          flexDirection={{ base: "column", md: "row" }}
          gap={{ base: 6, md: 0 }}
        >
          <Flex justifyContent={"center"} alignItems={"center"}>
            <Button
              variant="ghost"
              size={{ base: "xs", md: "sm" }}
              leftIcon={<IoArrowBackCircleOutline fontSize={"24px"} />}
              onClick={() => navigate(-1)}
              _hover={{ bg: "gray.100" }}
              color="gray.700"
              fontWeight="bold"
              className="p-0"
            ></Button>

            <Breadcrumb fontWeight="medium" fontSize="18px">
              <BreadcrumbItem isCurrentPage>
                <BreadcrumbLink href="#">User Roles</BreadcrumbLink>
              </BreadcrumbItem>
            </Breadcrumb>
          </Flex>
          {roleLoading
            ? userData?.accessScopes?.user_group?.includes("write") && (
                <Flex justifyContent="space-between">
                  <Flex gap="10px">
                    <Button
                      variant={"outline"}
                      colorScheme="teal"
                      size={"sm"}
                      py={5}
                      px={4}
                      onClick={handleAddRoleButtonClicked}
                    >
                      Add Roles
                    </Button>
                  </Flex>
                </Flex>
              )
            : null}
        </Flex>
        {roleLoading ? (
          <Box width="100%" maxW="none" mx={0} px={0}>
            {/* Mobile View */}
            {isMobile ? (
              <AdminRolesMobilePage
                roles={roles}
                isLoading={!roleLoading}
                userData={userData}
                handleEditRoleButtonClicked={handleEditRoleButtonClicked}
                openConfirmModal={openConfirmModal}
              />
            ) : (
              /* Desktop View */
              <>
                <Box
                  w="100%"
                  maxW="none"
                  borderRadius="lg"
                  overflow="hidden"
                  boxShadow="sm"
                  bg="white"
                  mx={0}
                  px={0}
                >
                  <TableContainer
                    w="100%"
                    maxW="none"
                    overflowX="auto"
                    height={`${window.innerHeight - 185}px`}
                    overflowY={"scroll"}
                  >
                    <Table variant="simple" w="100%">
                      <Thead
                        bg={"#E2DFDF"}
                        position={"sticky"}
                        top={"0px"}
                        zIndex={"99"}
                      >
                        <Tr>
                          <Th>S.No</Th>
                          <Th>Name</Th>
                          <Th>Description</Th>
                          <Th>Action</Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {roles?.map((item, i) => (
                          <Tr key={i}>
                            <Td
                              style={{
                                whiteSpace: "pre-wrap",
                                wordWrap: "break-word",
                              }}
                              fontSize={"14px"}
                            >
                              {i + 1}.
                            </Td>
                            <Td
                              style={{
                                whiteSpace: "pre-wrap",
                                wordWrap: "break-word",
                              }}
                              fontSize={"14px"}
                            >
                              {item.name}
                            </Td>

                            <Td
                              style={{
                                whiteSpace: "pre-wrap",
                                wordWrap: "break-word",
                              }}
                              fontSize={"14px"}
                            >
                              {item.description || "n/a"}
                            </Td>
                            <Td fontSize={"14px"}>
                              {item.name !== "New Admin" ? (
                                <Flex>
                                  {userData?.accessScopes?.user_group?.includes(
                                    "write"
                                  ) && (
                                    <Flex
                                      onClick={() =>
                                        handleEditRoleButtonClicked(item)
                                      }
                                      mr={1}
                                      cursor={"pointer"}
                                    >
                                      <Tooltip label="Edit Role">
                                        <Text>
                                          <MdEdit fontSize={"24px"} />
                                        </Text>
                                      </Tooltip>
                                    </Flex>
                                  )}
                                  {userData?.accessScopes?.user_group?.includes(
                                    "delete"
                                  ) && (
                                    <Flex
                                      cursor={"pointer"}
                                      onClick={() => openConfirmModal(item._id)}
                                    >
                                      <Tooltip label="Delete Role">
                                        <Text>
                                          <MdDelete fontSize={"24px"} />
                                        </Text>
                                      </Tooltip>
                                    </Flex>
                                  )}
                                </Flex>
                              ) : (
                                "--"
                              )}
                            </Td>
                          </Tr>
                        ))}
                      </Tbody>
                    </Table>
                  </TableContainer>
                </Box>
              </>
            )}

            {/* Modal for Create/Edit Role */}
            <Modal
              closeOnOverlayClick={false}
              isOpen={isOpen}
              onClose={onClose}
              p={3}
              size={{ base: "sm", md: "5xl" }}
              isCentered
            >
              <ModalOverlay />
              <ModalContent>
                <ModalHeader>
                  {showupdatebutton ? "Update Role" : "Create New Role"}
                </ModalHeader>
                <ModalCloseButton />
                <ModalBody p={6} textAlign="left">
                  <FormControl mb="10px">
                    <FormLabel>Role Name</FormLabel>
                    <Input
                      name="name"
                      onChange={handlerolechange}
                      value={roledetail.name}
                      placeholder="Enter Role"
                    />
                  </FormControl>

                  <FormControl mb="10px">
                    <FormLabel>Description</FormLabel>
                    <Input
                      name="description"
                      onChange={handlerolechange}
                      value={roledetail.description}
                      placeholder="Enter description of the Role"
                    />
                  </FormControl>

                  <FormControl mb="10px">
                    <FormLabel>Select Access Control</FormLabel>
                    <TableContainer>
                      <Table size="sm">
                        <Thead>
                          <Tr>
                            <Th> </Th>
                            <Th>
                              <Text>Read</Text>
                            </Th>
                            <Th>
                              <Text>Write</Text>
                            </Th>
                            <Th>
                              <Text>Delete</Text>
                            </Th>
                          </Tr>
                        </Thead>
                        <Tbody>
                          {accessroles.map((item, i) => (
                            <Tr key={i}>
                              <Td>
                                <FormControl>
                                  <Flex gap="10px">
                                    <Checkbox
                                      isChecked={
                                        rolecontroller[item]?.length === 3
                                      }
                                      onChange={(e) => handleAllrole(e, item)}
                                    />
                                    <FormLabel>
                                      {item.split("_").join(" ")}
                                    </FormLabel>
                                  </Flex>
                                </FormControl>
                              </Td>
                              <Td>
                                <Checkbox
                                  isDisabled={rolecontroller[item]?.some(
                                    (x) =>
                                      x === "write" ||
                                      x === "delete" ||
                                      (item === "coach" &&
                                        rolecontroller[item]?.includes("read"))
                                  )}
                                  isChecked={rolecontroller[item]?.includes(
                                    "read"
                                  )}
                                  onChange={(e) => handleReadRole(e, item)}
                                />
                              </Td>
                              <Td>
                                <Checkbox
                                  isChecked={rolecontroller[item]?.includes(
                                    "write"
                                  )}
                                  onChange={(e) => handleWriteRole(e, item)}
                                />
                              </Td>
                              <Td>
                                <Checkbox
                                  isChecked={rolecontroller[item]?.includes(
                                    "delete"
                                  )}
                                  onChange={(e) => handleDeleteRole(e, item)}
                                />
                              </Td>
                            </Tr>
                          ))}
                        </Tbody>
                      </Table>
                    </TableContainer>
                  </FormControl>

                  <Grid gap="15px" templateColumns="repeat(3,1fr)"></Grid>
                </ModalBody>
                <ModalFooter gap="10px">
                  {showupdatebutton ? (
                    <Button
                      onClick={handleupdateRoleHitApi}
                      variant={"outline"}
                      colorScheme="telegram"
                      size={"sm"}
                      py={5}
                      px={4}
                    >
                      {updateloader ? <Spinner /> : "Update"}
                    </Button>
                  ) : (
                    <Button
                      variant={"outline"}
                      colorScheme="green"
                      size={"sm"}
                      py={5}
                      px={4}
                      mr={1}
                      onClick={handleCreateRoleHitApi}
                    >
                      {createloader ? <Spinner /> : "Save"}
                    </Button>
                  )}

                  <Button
                    onClick={onClose}
                    variant={"outline"}
                    colorScheme="red"
                    size={"sm"}
                    py={5}
                    px={4}
                  >
                    Cancel
                  </Button>
                </ModalFooter>
              </ModalContent>
            </Modal>

            <ConfirmationModal
              heading="Delete Role"
              action="Are you Sure? You want to Delete this Role"
              ConfirmButton="Yes Delete"
              onClickFunction={handleDeleteRoleButtonClickedApiHit}
              isOpen={confirmisOpen}
              onClose={closeConfirmModal}
              loader={true}
              loading={deleteloader}
            />
          </Box>
        ) : (
          <Flex justifyContent={"center"} alignItems={"center"} mt={16}>
            <Spinner size={"lg"} />
          </Flex>
        )}
      </Layout>
    </Box>
  );
};

export default AdminRoles;
